class CookieManager {
  constructor(key) {
    this.key = key;
  }

  getItem(defaultValue = null) {
    const item = localStorage.getItem(this.key);
    if (item === null && defaultValue !== null) {
      this.setItem(defaultValue);
      return defaultValue;
    }
    return JSON.parse(item);
  }

  setItem(value) {
    localStorage.setItem(this.key, JSON.stringify(value));
  }

  removeItem() {
    localStorage.removeItem(this.key);
  }
}

const userKey = 'user';
const collapsedKey = 'collapsed';
const onBoardingVersionKey = 'onBoardingVersion';
const favoriteMerchantKey = 'favoriteMerchantId';
const spellcheckDisabledKey = 'spellcheckDisabled';

export const userCookieManager = new CookieManager(userKey);
export const collapseCookieManager = new CookieManager(collapsedKey);
export const onBoardingVersionManager = new CookieManager(onBoardingVersionKey);
export const favoriteMerchantManager = new CookieManager(favoriteMerchantKey);

export function getUserCookie() {
  return localStorage.getItem(userKey);
}

export function setUserCookie(user) {
  userCookieManager.setItem(user);
}

export function removeUserCookie() {
  userCookieManager.removeItem();
}

export function setCollapseCookie(value) {
  collapseCookieManager.setItem(value);
}

export function getCollapseCookie() {
  return collapseCookieManager.getItem('true');
}

export function getOnBoardingVersion() {
  const version = localStorage.getItem(onBoardingVersionKey);
  return version ? parseInt(version, 10) : null;
}

export function setOnBoardingVersion(version) {
  localStorage.setItem(onBoardingVersionKey, version);
}

export function getFavoriteMerchantId() {
  return localStorage.getItem(favoriteMerchantKey);
}

export function setFavoriteMerchantId(id) {
  localStorage.setItem(favoriteMerchantKey, id);
}

export const spellcheckCookieManager = new CookieManager(spellcheckDisabledKey);

export function getSpellcheckDisabled() {
  return spellcheckCookieManager.getItem(false);
}

export function setSpellcheckDisabled(value) {
  spellcheckCookieManager.setItem(value);
}
